import BarChartIcon from '@mui/icons-material/BarChart';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { publicCardSx, publicColors, publicContainerSx, publicH2Sx, publicSectionSx, publicSubtitleSx } from './publicTheme';

const blocks = [
    {
        icon: PrecisionManufacturingIcon,
        title: 'Produção sob controle',
        pain: 'Você não sabe quantas impressões falham, quanto filamento some nem qual máquina paga o custo fixo.',
        solution: 'Registre jobs, integre impressoras*, acompanhe status, duração e consumo. Veja taxa de sucesso por equipamento e período.',
    },
    {
        icon: ShoppingCartIcon,
        title: 'Vendas com margem visível',
        pain: 'Preço no feeling e vendas espalhadas geram encomenda lucrativa misturada com prejuízo.',
        solution: 'Precifique com calculadora, registre encomendas e vendas. Compare custo real (energia, material, tempo) com o que cobrou.',
    },
    {
        icon: BarChartIcon,
        title: 'Decisão com números',
        pain: 'Sem histórico consolidado, fica difícil saber se vale aceitar mais certos tipos de pedidos, comprar filamento ou subir preço.',
        solution: 'Dashboard com totais por status, intervalo de datas e visão financeira. Estatísticas para priorizar o que move o caixa.',
    },
];

const PlatformDetails = () => (
    <Box id="plataforma" component="section" sx={{ ...publicSectionSx, bgcolor: publicColors.surface }}>
        <Box sx={publicContainerSx}>
            <Typography component="h2" sx={{ ...publicH2Sx, textAlign: 'center' }}>
                Uma plataforma para a dor de quem vive de impressão 3D
            </Typography>
            <Typography sx={{ ...publicSubtitleSx, textAlign: 'center', mb: 5 }}>
                Não é ERP genérico: é gestão de produção e vendas com métricas que respondem
                perguntas do dia a dia do maker profissional.
            </Typography>
            <Grid container spacing={3}>
                {blocks.map(({ icon: Icon, title, pain, solution }) => (
                    <Grid item xs={12} md={4} key={title}>
                        <Box sx={publicCardSx}>
                            <Box
                                sx={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: 1.5,
                                    bgcolor: publicColors.primarySoft,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 2,
                                }}
                            >
                                <Icon sx={{ color: publicColors.primary, fontSize: 28 }} />
                            </Box>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: publicColors.ink, mb: 1.5 }}>
                                {title}
                            </Typography>
                            <Typography variant="body2" sx={{ color: publicColors.danger, fontWeight: 600, mb: 1 }}>
                                {pain}
                            </Typography>
                            <Typography variant="body2" sx={{ color: publicColors.inkMuted, lineHeight: 1.65 }}>
                                {solution}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            <Typography
                variant="caption"
                display="block"
                textAlign="center"
                sx={{ mt: 4, color: publicColors.inkSoft }}
            >
                Recursos marcados com * estão disponíveis apenas para os planos pagos.
            </Typography>
        </Box>
    </Box>
);

export default PlatformDetails;
